<template lang="pug">
.plan-form
    SvButton.plan-form__remove(
        view="shadow"
        icon
        :prependIcon=`{
            icon: 'trash',
            width: 24,
            height: 24,
            hover: '#1993EB',
            default: '#B7BAC6'
        }`
        @click="remove"
    )

    .plan-form__image-wrapper
        img.plan-form__image(
            :src="uploadImage || value.preview_picture || value.original_image"
        )

        .plan-form__image-hover
            //- SvButton(
            //-     view="shadow"
            //-     text="Изменить"
            //-     @click="changeImage"
            //- )
            SvUpload.form-residential-photo__upload(
                v-model="original_image"
                :isImage="false"
            )

    .plan-form__input-container
        SvSelect(
            v-model="rooms_id"
            placeholder="Кол-во комнат"
            :items="itemsRooms"
        )

        SvInput.plan-form__input(
            v-model="area"
            type="number"
            placeholder="Площадь в м2"
            :withIcon="false"
        )

        SvInput.plan-form__input(
            v-model="floors"
            placeholder="Наличие по этажам"
            :withIcon="false"
        )

        .plan-form__balcony
            span.plan-form__balcony-label
                | Балкон

            .plan-form__balcony-group
                SvRadio(
                    v-model="has_balcony"
                    label="Да"
                    :value="true"
                )

                SvRadio(
                    v-model="has_balcony"
                    label="Нет"
                    :value="false"
                )
</template>

<script>
import SvButton from '@/components/uikit/SvButton.vue';
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';

export default {
  name: 'PlanForm',
  data(){
    return {
      uploadImage: null
    }
  },
  mounted() {
  },

  components: {
    SvSelect,
    SvInput,
    SvRadio,
    SvButton,
    SvUpload
  },

  props: {
    value: {
      type: Object,
      required: true,
    },

    itemsRooms: {
      type: Array,
      required: true,
    },
  },

  computed: {
    area: {
      get() { return this.value.area; },
      set(area) { this.setValue({ area }); },
    },

    has_balcony: {
      get() { return this.value.has_balcony; },
      set(has_balcony) { this.setValue({ has_balcony }); },
    },

    floors: {
      get() { return this.value.floors; },
      set(floors) { this.setValue({ floors }); },
    },

    rooms_id: {
      get() { return this.value.rooms_id; },
      set(rooms_id) { this.setValue({ rooms_id }); },
    },

    original_image: {
      get() {
        return this.value.original_image;
      },
      set(original_image) {
        this.uploadImage = original_image;
        this.setValue({ original_image });
      },
    },
  },

  methods: {
    setValue(val) {
      this.$emit('input', {
        ...this.value,
        ...val,
      });
    },

    remove() {
      this.$emit('remove');
    },

    changeImage(arg) {
      const detail_picture = window.URL.createObjectURL(arg.target.files[0]);
      this.setValue({ original_image: detail_picture });
    },
  },
};
</script>

<style lang="scss" scoped>
.plan-form {
    position: relative;
    box-shadow: 0px 5px 20px rgba(3, 62, 105, 0.08);
    border: 1px solid #E4E4EE;
    border-radius: 6px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__remove {
        position: absolute;
        right: 3px;
        top: 3px;
        z-index: 10;
    }

    &__image-wrapper {
        position: relative;
        height: 217px;
        width: 207px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            .plan-form__image-hover {
                opacity: 1;
            }
        }
    }

    &__image-hover {
        opacity: 0;
        position: absolute;
        background-color: rgba(255, 255, 255, .7);
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__image {
        max-width: 207px;
        max-height: 217px;
        text-align: center;
    }

    &__input-container {
        width: 215px;
        margin-top: 30px;
    }

    &__input,
    &__balcony {
        margin-top: 20px;
    }

    &__balcony {
        display: flex;

        &-label {
            margin-right: 40px;
        }

        &-group {
            display: flex;
            justify-content: space-between;
            width: 100%;
        }
    }
}
</style>
